import { formatValue, formatValueBillion } from '../../helpers/Text';

export const isFormatBillion = value => value >= 500000000;

export const getFormatter = value => {
  return isFormatBillion(value) ? formatValueBillion : formatValue;
};
